/** Shared dummy catalog for seller product table, drawer, and edit page. */

export const SELLER_PRODUCTS_LIST = [
  {
    id: 1,
    name: "Leather Handbag",
    sku: "SKU-001",
    category: "Accessories",
    price: "$100",
    stock: 140,
    status: "in-stock",
  },
  {
    id: 2,
    name: "Leather Handbag",
    sku: "SKU-002",
    category: "Accessories",
    price: "$100",
    stock: 0,
    status: "sold-out",
  },
  {
    id: 3,
    name: "Leather Handbag",
    sku: "SKU-003",
    category: "Accessories",
    price: "$100",
    stock: 12,
    status: "low-stock",
  },
  {
    id: 4,
    name: "Leather Handbag",
    sku: "SKU-004",
    category: "Accessories",
    price: "$100",
    stock: 200,
    status: "in-stock",
  },
];

const IMG = (seed, w = 720, h = 480) =>
  `https://picsum.photos/seed/${seed}/${w}/${h}`;

function enrich(listRow) {
  const id = listRow.id;
  return {
    ...listRow,
    categoryDetail: "Basic",
    description:
      "Thoughtfully designed for everyday use. Premium materials, refined stitching, and a silhouette that moves from weekday errands to evening plans without missing a beat. Dimensions: 28 × 22 × 12 cm. Interior pocket for essentials.",
    weight: "0.5",
    totalOrders: 84,
    images: [
      IMG(`seller-${id}-a`),
      IMG(`seller-${id}-b`),
      IMG(`seller-${id}-c`),
    ],
    discount: "",
    lowStockAlert: "10",
    deliveryProcessingTime: "2 days",
    origin: "nigeria",
    tags: "handmade, gifts, leather",
    videoUrl: "",
    listingActive: false,
    priceNumber: "100",
  };
}

export function getSellerProductDetail(id) {
  const row = SELLER_PRODUCTS_LIST.find(
    (p) => String(p.id) === String(id)
  );
  if (row) return enrich(row);

  const nid = Number(id);
  if (!Number.isFinite(nid)) return null;

  return enrich({
    id: nid,
    name: "Leather Handbag",
    sku: `SKU-${String(nid).padStart(3, "0")}`,
    category: "Accessories",
    price: "$100",
    stock: 100,
    status: "in-stock",
  });
}
